var _path, _path2, _rect, _path3, _path4, _line, _line2, _line3, _line4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprayingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4355 12.3838V8.9829L20.5234 6.99902H9.24145L6.81964 8.9829V12.3838",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8687 10.2299L20.4648 6.99902H8.88753L10.3876 10.2299H18.8687Z",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.850966,
    y: 0.850966,
    width: 14.6463,
    height: 3.98441,
    rx: 1.99221,
    transform: "matrix(-1 0 0 1 21.2688 1.61426)",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2695 3.33653C28.7395 3.33653 29.1205 3.71752 29.1205 4.1875C29.1205 4.65748 28.7395 5.03847 28.2695 5.03847V3.33653ZM23.4232 5.03847H22.5722V3.33653H23.4232V5.03847ZM28.2695 5.03847H23.4232V3.33653H28.2695V5.03847Z",
    fill: "#0F5EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57715 3.33653H7.42811V5.03847H6.57715V3.33653ZM1.73083 5.03847C1.26086 5.03847 0.879866 4.65748 0.879866 4.1875C0.879866 3.71752 1.26086 3.33653 1.73083 3.33653V5.03847ZM6.57715 5.03847H1.73083V3.33653H6.57715V5.03847Z",
    fill: "#0F5EFF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.850966,
    y1: -0.850966,
    x2: 1.28141,
    y2: -0.850966,
    transform: "matrix(4.37103e-08 1 1 -4.37103e-08 26.5811 2.15234)",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.850966,
    y1: -0.850966,
    x2: 1.28141,
    y2: -0.850966,
    transform: "matrix(4.37103e-08 1 1 -4.37103e-08 4.12402 2.15234)",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "square"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.850966,
    y1: -0.850966,
    x2: 2.37991,
    y2: -0.850966,
    transform: "matrix(-1 0 0 1 27.4619 2.15234)",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.850966,
    y1: -0.850966,
    x2: 2.37991,
    y2: -0.850966,
    transform: "matrix(-1 0 0 1 5.2002 2.15234)",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 12.2764L14.667 13.698",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 15.1191L14.667 16.5407",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 17.9629L14.667 19.3845",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1416 12.2773L11.6525 13.6121",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1611 14.9463L10.672 16.2811",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1836 17.6162L9.69445 18.951",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5049 12.2773L17.994 13.6121",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4854 14.9463L18.9745 16.2811",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4629 17.6162L19.952 18.951",
    stroke: "#0F5EFF",
    strokeWidth: 1.70193,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprayingicon);
export default __webpack_public_path__ + "static/media/sprayingicon.681e4c6424985bbf94a1aa10ba1b25aa.svg";
export { ForwardRef as ReactComponent };